export const objectiveToOpportunity = (obj) => {
  if (!obj) {
    return null;
  }

  let prevDesc = [];
  if (obj.description) {
    try {
      prevDesc = JSON.parse(obj.description)?.blocks || [];
    } catch (e) {
      prevDesc = [];
    }
  }

  const description_30_day = obj?.description_30_day;
  const description_60_day = obj?.description_60_day;
  const description_90_day = obj?.description_90_day;

  const milestones =
    Array.isArray(obj?.milestones) && obj?.milestones.length
      ? obj?.milestones.reduce((acc, i) => {
          if (acc[i.milestone_type]) {
            return { ...acc, [i.milestone_type]: [...acc[i.milestone_type], i] };
          }

          return { ...acc, [i.milestone_type]: [i] };
        }, {})
      : [];

  return {
    blocks: [
      ...prevDesc,
      { key: '8fm3r', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
      {
        key: '3t1o8',
        text: 'Key Result: ' + description_90_day,
        type: 'blockquote',
        depth: 0,
        inlineStyleRanges: [{ offset: 0, length: 10, style: 'BOLD' }],
        entityRanges: [],
        data: {},
      },
      ...(milestones?.[90]
        ? milestones?.[90]?.map((ms) => {
            return {
              key: ms.id,
              text: ms.description,
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            };
          })
        : []),
      { key: '8fm3r2', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
      {
        key: '3ik54',
        text: '30 Day Milestone: ' + description_30_day,
        type: 'blockquote',
        depth: 0,
        inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
        entityRanges: [],
        data: {},
      },
      ...(milestones?.[30]
        ? milestones?.[30]?.map((ms) => {
            return {
              key: ms.id,
              text: ms.description,
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            };
          })
        : []),
      { key: '8fm3r3', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
      {
        key: '3ik55',
        text: '60 Day Milestone: ' + description_60_day,
        type: 'blockquote',
        depth: 0,
        inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
        entityRanges: [],
        data: {},
      },
      ...(milestones?.[60]
        ? milestones?.[60]?.map((ms) => {
            return {
              key: ms.id,
              text: ms.description,
              type: 'unordered-list-item',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
              data: {},
            };
          })
        : []),
    ],
    entityMap: {},
  };
};
